import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Import Link component
import "./Banner.css";

export default function Banner() { 
  return (
    <Container className="banner-container" fluid="true">
      <Row className="banner-row" fluid="true">
        <Col xs={6} sm={4} md={2} className="banner-tab">
          <Link to="/" className="nav-link">
            <div>Home</div>
          </Link>
        </Col>
        <Col xs={6} sm={4} md={2} className="banner-tab">
          <Link to="/about" className="nav-link">
            <div>About Us</div>
          </Link>
        </Col>
        <Col xs={6} sm={4} md={2} className="banner-tab">
          <Link to="/registrations" className="nav-link">
            <div>Registrations</div>
          </Link>
        </Col>
        <Col xs={6} sm={4} md={2} className="banner-tab">
          <Link to="/contact" className="nav-link">
            <div>Contact Us</div>
          </Link>
        </Col>
        <Col xs={6} sm={4} md={2} className="banner-tab">
          <Link to="/gallery" className="nav-link">
            <div>Photo Gallery</div>
          </Link>
        </Col>
        <Col xs={6} sm={4} md={2} className="banner-tab">
          <Link to="/private-instruction" className="nav-link">
            <div>Private Instruction</div>
          </Link>
        </Col>
      </Row>
    </Container>
  );
}
